import * as React from "react";
import { PageLayout } from "src/components/PageLayout";

export const TestPage: React.FC = () => (
  <PageLayout title="Test page">Test-Заглушка</PageLayout>
);
